var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"relative flex flex-col bg-white md:ml-[75px] mt-[-1px]",class:{ [`z-${_vm.z}`]: true },attrs:{"data-scroll-section":""}},[_c('div',{staticClass:"absolute top-[-2px] w-[75px] bottom-[-1px] left-[-75px] hidden md:block bg-gray-100"}),_vm._v(" "),_c('div',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }